import dayjs from 'dayjs';
import 'dayjs/locale/ru';

dayjs.locale('ru');

const rubles = new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 0 });
const kopecks = new Intl.NumberFormat('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

/** 27 500 ₽ или 27 500,50 ₽: копейки — двумя знаками или никак («27 500,5» читается как ошибка). */
export const money = (v: string | number | null | undefined) => {
  if (v === null || v === undefined || v === '') return '—';
  const n = Number(v);
  return `${(Number.isInteger(n) ? rubles : kopecks).format(n)} ₽`;
};

export const day = (iso: string) => dayjs(iso).format('D MMM');
export const fullDay = (iso: string) => dayjs(iso).format('D MMMM YYYY');
export const monthName = (iso: string) => {
  const s = dayjs(iso).format('MMMM YYYY');
  return s.charAt(0).toUpperCase() + s.slice(1);
};
export const isoDay = (d: Date | string) => dayjs(d).format('YYYY-MM-DD');
export const monthStart = (d: Date | string) => dayjs(d).startOf('month').format('YYYY-MM-DD');
export const monthEnd = (d: Date | string) => dayjs(d).endOf('month').format('YYYY-MM-DD');

export { dayjs };
